"use client";

import { redirect, useParams } from "next/navigation";
import React from "react";
import FloorPlanGalleryProvider from "@/components/providers/FloorPlanGalleryProvider";
import Main from "@/components/ui/layout/main";
import { GetInspiredSection } from "@/components/ui/sections/GetInspired";
import { OurBuildRenovateProcess } from "@/components/ui/sections/OurBuildRenovateProcess";
import { URLS } from "@/lib/consts";
import { capitalizeFirstCharactersForEachWord } from "@/lib/utils";
import { FLOOR_PLANS_NAMES } from "../consts";
import type { FloorPlanName, UrlFloorPlanName } from "../types";
import { ContactUsSection } from "./ui/ContactUsSection";
import { DetailsSection } from "./ui/DetailsSection";
import { FloorPlansNameHero } from "./ui/FloorPlansNameHero";
import { GallerySection } from "./ui/GallerySection";

function Page() {
  const { "floor-plan-name": floorPlanName } = useParams<{
    "floor-plan-name": UrlFloorPlanName;
  }>();
  const formattedFloorPlanName = capitalizeFirstCharactersForEachWord(
    floorPlanName,
    "-",
  ) as FloorPlanName;

  if (!FLOOR_PLANS_NAMES.includes(floorPlanName)) {
    redirect(URLS.FLOOR_PLANS);
  }

  return (
    <FloorPlanGalleryProvider>
      <FloorPlansNameHero floorPlanName={formattedFloorPlanName} />
      <Main padding="py-0 px-0" sm="" md="" lg="">
        <GallerySection floorPlanName={formattedFloorPlanName} />
        <DetailsSection floorPlanName={formattedFloorPlanName} />
        <ContactUsSection />
        <OurBuildRenovateProcess />
        <GetInspiredSection />
      </Main>
    </FloorPlanGalleryProvider>
  );
}

export default Page;
